<template>
  <span>
    <v-subheader class="mr-8 mt-4">
      <v-list-item-avatar>
        <v-icon color="primary">{{ icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="font-weight-bold">
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ subtitle }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <slot name="action"></slot>
      </v-list-item-action>
    </v-subheader>
    <v-divider inset></v-divider>
    <slot name="extra-config"></slot>
  </span>
</template>
<script>
export default {
  name: "DashboardItemsConfigHeader",
  props: ["title", "subtitle", "icon"],
};
</script>
